export default __webpack_public_path__ + "static/region-flag-na-5b900ae24f1cb6c9b5492b4f973da64b.svg";